<template>
  <div class="base-popup">
    <div class="base-popup__content">
      <div class="base-popup__actions">
        <slot name="actions"/>
        <button class="base-popup__close-button" @click="$emit('close')">
          <close-icon />
        </button>
      </div>
      <slot />
    </div>
  </div>
</template>

<script>
import CloseIcon from '@components/svg/CloseIcon.vue'

export default {
  name: 'BasePopup',
  components: { CloseIcon }
}
</script>

<style>
.base-popup * {
  box-sizing: border-box;
}

.base-popup {
  width: 100%;
  height: 100%;
  z-index: 999;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  animation-name: fade-in;
  animation-duration: 0.6s;
}

@keyframes fade-in {
  0% { opacity: 0; }
  100% { opacity: 1; }
}

.base-popup__content {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  margin: 15px;
  padding: 15px;
  background: #fff;
  border-radius: 5px;
  overflow-y: auto;
}

.base-popup__actions {
  position: absolute;
  top: 15px;
  right: 15px;
  display: flex;
  justify-content: flex-end;
}

.base-popup__close-button {
  padding: 5px;
  color: #000000;
  font-size: 14px;
  background: transparent;
  border: 1px solid #000000;
  border-radius: 5px;

  display: flex;
  align-items: center;
  user-select: none;
}

.base-popup__close-button:hover{
  color: #2EA3FF;
  border: 1px solid #2EA3FF;
  cursor: pointer;
}

@media print {
  .base-popup__close-button {
    display: none;
  }
}
</style>
